export const ADMIN_ROLE = "ROL_PORTAL_ECM_PROD_ADMIN";
export const TEST_ADMIN_ROLE = "ROL_PORTAL_ECM_TEST_ADMIN";
export const DIGITAL_ROLE = "G_USR_PORTAL_ECM_PROD_DIGITAL";
export const TEST_DIGITAL_ROLE = "G_USR_PORTAL_ECM_TEST_DIGITAL";
export const OPERADOR_ROLE = "ROL_PORTAL_ECM_PROD_OPERADOR";
export const TEST_OPERADOR_ROLE = "ROL_PORTAL_ECM_TEST_OPERADOR";

export const VALID_ROLES = [
  ADMIN_ROLE,
  TEST_ADMIN_ROLE,
  DIGITAL_ROLE,
  TEST_DIGITAL_ROLE,
  OPERADOR_ROLE,
  TEST_OPERADOR_ROLE,
];

export const CURRENT_MODULES_ROLES = [
  ADMIN_ROLE,
  TEST_ADMIN_ROLE,
  OPERADOR_ROLE,
  TEST_OPERADOR_ROLE,
];

export const NEW_MODULES_ROLES = [
  ADMIN_ROLE,
  TEST_ADMIN_ROLE,
  DIGITAL_ROLE,
  TEST_DIGITAL_ROLE,
];
